import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const DuplicateIconSvg = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 18 18' fill='none'>
    <path
      d='M15.8888 0.666664H5.78795C4.99101 0.666664 4.34497 1.31271 4.34497 2.10964V12.2105C4.34497 13.0074 4.99101 13.6535 5.78795 13.6535H15.8888C16.6857 13.6535 17.3318 13.0074 17.3318 12.2105V2.10964C17.3318 1.31271 16.6857 0.666664 15.8888 0.666664Z'
      stroke='currentColor'
      strokeWidth='1.2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.8374 4.27425V10.0462'
      stroke='currentColor'
      strokeWidth='1.2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7.95166 7.16015H13.7236'
      stroke='currentColor'
      strokeWidth='1.2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.7251 15.4574C13.7251 15.9167 13.5427 16.4292 13.2179 16.754C12.8932 17.0787 12.4528 17.2612 11.9935 17.2612H2.46986C2.01061 17.2612 1.57018 17.0787 1.24545 16.754C0.920714 16.4292 0.738281 15.9888 0.738281 15.5296V6.00592C0.738281 5.54668 0.920714 5.10624 1.24545 4.78151C1.57018 4.45678 2.15491 4.27435 2.61415 4.27435'
      stroke='currentColor'
      strokeWidth='1.2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const DuplicateIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={DuplicateIconSvg} {...props} />
);
